var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9133 11.2151V3.30003C19.9133 1.13443 15.9351 0 12.0048 0C8.07444 0 4.09618 1.13443 4.09618 3.30003V11.22C1.45049 12.139 0 13.4786 0 15.0193C0 18.2554 6.18423 20.0009 12 20.0009C17.8158 20.0009 24 18.2554 24 15.0193C24 13.479 22.5543 12.1395 19.9133 11.2156V11.2151ZM5.42356 5.26539C6.92113 6.17946 9.46748 6.65102 12 6.65102C14.5325 6.65102 17.0836 6.1817 18.5764 5.26539V13.7083C18.5764 14.3587 16.2564 15.6303 12 15.6303C7.74357 15.6303 5.42356 14.3641 5.42356 13.7083V5.26539ZM12 1.37892C16.2564 1.37892 18.5764 2.65013 18.5764 3.30093C18.5764 3.95173 16.2547 5.27031 12 5.27031C7.74529 5.27031 5.42356 3.9553 5.42356 3.30003C5.42356 2.64476 7.74529 1.37892 12 1.37892ZM12 18.6171C5.89612 18.6171 1.33084 16.7152 1.33084 15.014C1.33084 14.2121 2.36752 13.3517 4.08495 12.6772V13.7052C4.08495 15.8708 8.06321 17.0053 11.9935 17.0053C15.9238 17.0053 19.9021 15.8708 19.9021 13.7052V12.6772C21.6221 13.3517 22.6566 14.2121 22.6566 15.014C22.6661 16.7152 18.1022 18.6171 11.9983 18.6171H12Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.fc21b005.svg";
export { ForwardRef as ReactComponent };